import React, { useState, useEffect } from 'react';
import { ThemeProvider } from "@material-ui/core"
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
//import DataTable from './DataTable';
//import PlannedIdleTime from './PlannedIdleTime';
//import UnplannedIdleTime from './UnplannedIdleTime';
//import IHFTime from './IHFTime';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import axios from 'axios';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
//Autocomplete
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from "material-table";
//import { tableOptionsUser } from "../../SharedComponents/SharedComponentStyles";
import { forwardRef } from "react";
import {
    AddBox,
    Check,
    DeleteOutline,
    Edit,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Clear,
    Search,
    ArrowDownward,
    Remove,
    ViewColumn,
} from "@material-ui/icons";


const api = axios.create({
    baseURL: 'InventoryAudit'
})

const apiSlip = axios.create({
    baseURL: 'SlipGeneration'
})
export const tableIconsInputScreen = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => (
        <Check {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Clear: forwardRef((props, ref) => (
        <Clear {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
        <Edit {...props} style={{ fontSize: "large", padding: 0 }} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
export const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => (
        <DeleteOutline {...props} ref={ref} style={{ color: "var(--red)" }} />
    )),
    DetailPanel: forwardRef((props, ref) => (
        <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
        <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => (
        <Search {...props} ref={ref} style={{ fontSize: "2.5rem" }} />
    )),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
//const useStyles = makeStyles((theme: Theme) =>
//    createStyles({
//        container: {
//            display: 'flex',
//            flexWrap: 'wrap',
//        },
//    }),
//);
const data = [
    {
        id: "12345678",
        firstName: "0001-HFHJS",
        lastName: "16.5",
        emailId: "sriyanka",
        phone: "9/01/2023  10:12:23",

    }
];
export const tableHeaderStyle = {
    backgroundColor: "var(--light-sand)",
    //backgroundColor: "var(--landing-page-card-bg-color)",
    //color: "var(--dark-blue)",
};
export const tableOptionsUser = {
    headerStyle: tableHeaderStyle,
    showTitle: false,
    draggable: false,
    pageSize: 3,
    // search: true,
    // add: true,
    pageSizeOptions: [5, 10, 25, 50],
    paginationPosition: "bottom",
    //paging: false,
    maxBodyHeight: "600px",
};

export default function AuditInventory(props) {
    //const classes = useStyles();

    //for progress
    var columns = [
        { title: " Slip Number", field: "auditSlipNumber" },
        
        { title: "Plant Name", field: "plantName" },
        { title: "Location", field: "locationName" },
        { title: "Material Name", field: "material" },
        { title: "Material Description", field: "materialDescription" },
        { title: " ABC Classification", field: "abcclassiification" },
        { title: "Unit Of Measure", field: "unitOfMeasurement" },
        { title: "Counted Physical Quantity", field: "countedPhyQuantity" },
        { title: "Remarks", field: "auditedQuantity" },
        { title: "Slip Created By", field: "mismatchQuantity" },
        { title: "Slip Modified By", field: "remarks" },
        { title: "Slip Creation Timestamp", field: "auditeddBy" },
        { title: "Slip Modification Timestamp", field: "createdDate" },

    ];

    const [openLoader, setopenLoader] = useState(false);

    //for Warning showing
    const [openWarning, setopenWarning] = useState(false);
    const [openAlertWarning, setopenAlertWarning] = useState("");
    const [openClassNameWarning, setopenClassNameWarning] = useState("");
    const [openTypeWarning, setopenTypeWarning] = useState("");
    const [alertwarningclass, setalertwarningclass] = useState("bg-amber clr-white");
    const [alertwarning, setalertwarning] = useState("Warning");

    //for error handling 
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [severity, setSeverity] = useState('success');

    //Autocomplete
    const [employeeObj, setEmployeeObj] = useState('');
    const [employeeText, setEmployeeText] = useState('');

    

    const handleErrorClose = (e) => {
        setIserror(false);
    }

    function handleCloseWarning() {
        setopenWarning(false);
    }

    
    const tableHeaderStyle = {
        backgroundColor: "var(--light-sand)",
        color: "var(--dark-blue)",
    };
    const tableOptions = {
        headerStyle: tableHeaderStyle,
        showTitle: false,
        draggable: false,
        pageSize: 5,
        pageSizeOptions: [5, 10, 25, 50],
        paginationPosition: "bottom",
        //paging: false,
        maxBodyHeight: '600px',
        // exportButton: true,
        // exportAllData: true
    };
    function getURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            var value = getParamName(sParameterName, sParam);
            return value;
        }
    }

    function getParamName(sParameterName, sParam) {
        var value = '';
        for (var j = 0; j < sParameterName.length; j++) {
            if (sParameterName[j] == sParam) {
                value = value + getParanValue(j, sParameterName);
                break;
            }
            else {
                continue;
            }
        }
        return value;
    }

    function getParanValue(j, sParameterName) {
        var value = '';
        for (var k = j + 1; k < sParameterName.length; k++) {
            value = value + sParameterName[k];
        }
        return value;
    }

    const today = Date.now();
    let newdateformat = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(today);
    let ldate = newdateformat.split("/")[2] + "-" + newdateformat.split("/")[0] + "-" + newdateformat.split("/")[1];
    const [entrydate, setentrydate] = useState(ldate);
    const [isDisabled, setisDisabled] = useState(true);
    




    //NEW FUNCS
    function clear() {
        
    }

    useEffect(() => {
       


    }, []);
   

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1"></h3>
                </Box>
                <Grid container spacing={2} className="d-flex mt-1 fd-row mb-1 px-1 box-shadow width-100 bdr-radius ">
                    <Grid item xs={12} sm={12} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity={severity} onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        item
                        xs={12}
                        className="d-flex jc-space-bt"
                    >
                        <Grid item xs={12} className="text-left ml-1">
                            <h3>Bulk Upload</h3>
                        </Grid>
                        <Grid container spacing={2} xs={12}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    id="RTCUploadFile"
                                    variant="filled"
                                    className="bulk-upload"
                                    type="file"
                                    name="bulkUpload"
                                   // key={inputFileValue}
                                    //onChange={(e) => filePathset_Value(e)}
                                />
                            </Grid>
                        <Grid item xs={12} md={2} className="d-flex jc-center width-100">
                                <Button
                                className="ns-btn-primary mt-1 mr-1"
                                    type="submit"
                                    // disabled={selectedFile ? false : true}
                                   // onClick={submitDatacall}
                                >
                                    Upload
                                </Button>
                            </Grid>

                            <Grid container xs={12} >
                            <Grid item xs={12} md={3} >
                                    <a
                                       // href={RTC_ManualUpload}
                                        download="RTC_ManualUpload"
                                        target="_blank"
                                    >
                                    <Button className="ns-btn-primary mt-1 mr-1">
                                            Download Template
                                        </Button>
                                    </a>
                                </Grid>
                            </Grid>

                            {/*<Grid*/}
                            {/*    container*/}
                            {/*    xs={12}*/}
                            {/*//   className="d-flex jc-space-bt"*/}
                            {/*>*/}
                            {/*    <Grid item xs={12} md={2}>*/}
                            {/*        <a*/}
                            {/*           // href={ViewRTC}*/}
                            {/*            onClick={(event) => (window.location.href = "/ViewRTC")}*/}
                            {/*            target="_blank"*/}
                            {/*        >*/}
                            {/*            <Button className="pt-button--primary bulk-upload-submit-btn">*/}
                            {/*                View RTC Data*/}
                            {/*            </Button>*/}
                            {/*        </a>*/}
                            {/*    </Grid>*/}
                            {/*</Grid>*/}
                        </Grid>
                        <Grid container xs={12} >
                            <Grid item xs={12} md={3} >
                                <a
                                    // href={RTC_ManualUpload}
                                    download="RTC_ManualUpload"
                                    target="_blank"
                                >
                                    <Button>
                                    </Button>
                                </a>
                            </Grid>
                        </Grid>
                   

                    <Grid item xs={12}>
                        <h5>
                            Inserted/Updated successfully :{" "}
                            {/*{uploadRes.successCnt ? uploadRes.successCnt : "0"}{" "}*/}
                        </h5>
                        <h5>
                            Failed Records :{/* {uploadRes.failedCnt ? uploadRes.failedCnt : "0"}*/}
                        </h5>
                    </Grid>

                    <div className="marginTop">
                        <Grid item xs={12}>
                            <MaterialTable
                                title="Failed RTC List"
                                columns={columns}
                                //data={uploadRes.rtcFailedRecord}
                                icons={tableIconsInputScreen}
                                //isLoading={isLoader}
                                options={{ tableOptionsUser, exportButton: { csv: true } }}
                            />
                        </Grid>
                    </div>
                    

                    </Grid>
                    </Grid>
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>


            </div>
        </ThemeProvider>
    );
}


